import React, { forwardRef, ChangeEvent, FocusEvent } from 'react'
import { TextInputIconType, TextInput } from 'components/atoms/TextInput'

interface ITriggerProps {
  dataTest?: string
  disabled?: boolean
  error?: string
  label: string
  listbox: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void
  onClearButtonClick?: Function
  placeholder?: string
  required?: boolean
  textBoxID: string
  type?: 'location' | string
  value?: string
  large?: boolean
  clearable?: boolean
  ariaLabel?: string
}

const AutoCompleteTrigger = forwardRef<HTMLInputElement, ITriggerProps>(
  (
    {
      ariaLabel = '',
      clearable = true,
      dataTest,
      disabled,
      error,
      label,
      large,
      listbox,
      onBlur,
      onChange,
      onClearButtonClick,
      onFocus,
      placeholder,
      required,
      type,
      value = '',
    },
    ref
  ) => (
    <TextInput
      aria-autocomplete='list'
      aria-controls={listbox}
      dataTest={dataTest}
      disabled={disabled}
      icon={type === 'location' ? TextInputIconType.locationPin : undefined}
      invalid={!!error}
      label={label}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      clearable={clearable}
      onClearButtonClick={onClearButtonClick}
      placeholder={placeholder}
      ref={ref}
      required={required}
      validationMessage={error}
      value={value}
      large={large}
      aria-label={ariaLabel}
      autoComplete='off'
    />
  )
)

export default AutoCompleteTrigger
